import React from "react";
import "./index.css";
import App from "./App";
import store from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { IntercomProvider } from "react-use-intercom";
import {createRoot} from "react-dom/client"

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <IntercomProvider appId={INTERCOM_APP_ID} autoBoot={true}>
        <App />
      </IntercomProvider>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
